export default "__VITE_ASSET__D9Vvn$Fz__"